<nav mat-tab-nav-bar [tabPanel]="tabPanel" class="border-b-0 w-full pr-4 !items-center">
  <a
    class="button-chip !mr-4"
    *ngFor="let link of navLinks"
    #rla="routerLinkActive"
    [routerLinkActiveOptions]="{ exact: false }"
    (click)="getCurrentTab(link.path)"
    [routerLink]="link.path"
    routerLinkActive="selected"
    queryParamsHandling="preserve"
    routerLinkActive="selected"
    [attr.data-path]="link.path"
    i18n
  >
    {{ link.alternateLabel ? link.alternateLabel : link.label }}
    <span *ngIf="link.path === 'my-collection'" tourAnchor="collections-tab.anchor" class="guided-tour-target absolute overlay-target"></span>
    <span *ngIf="link.path === 'published'" tourAnchor="public-collections-tab.anchor" class="guided-tour-target absolute overlay-target"></span>
  </a>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
